export const getRandomDate = () =>
  new Date(new Date().getTime() - Math.random() * 1e12);
export const getRandomItem = (data: any[]) =>
  data[Math.floor(Math.random() * data.length)];
export const getRandomNumber = (min: number, max: number) =>
  Math.floor(Math.random() * (max + 1 - min) + min);
export const getRandomDateBetweenRange = (from: Date, end: Date) =>
  new Date(getRandomNumber(from.getTime(), end.getTime()));
